import styled, { css } from 'styled-components';
import { layout, media } from 'src/components/base';
import { IconDropdownDown } from '@prisjakt/ui/icon/dropdown-down';
import { IconDropdownUp } from '@prisjakt/ui/icon/dropdown-up';

export const ProductListingHeaderRoot = styled.div`
  background-color: ${({ theme }) => theme.bg.secondary};
  font-size: 12px;
  display: table-header-group;
  border-bottom: 1px solid ${({ theme }) => theme.lines.secondary};

  ${media.mediumDown`
    display: none;
  `}
`;

const iconStyles = css`
  display: none;
`;

export const SortAscIcon = styled(IconDropdownUp).attrs({ color: 'base800' })`
  ${iconStyles}
`;

export const SortDescIcon = styled(IconDropdownDown).attrs({
  color: 'base800',
})`
  ${iconStyles}
`;

export const ProductListingHeaderCell = styled.a<{
  selected?: boolean;
  width?: number;
}>`
  color: ${({ theme }) => theme.text.secondary};
  display: table-cell;
  padding: 10px 8px 10px 0px;
  vertical-align: middle;
  line-height: 18px;
  position: relative;
  outline: 0;

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.text.primary};
    & ${/* sc-selector */ SortAscIcon}, & ${/* sc-selector */ SortDescIcon} {
      display: inline-flex;
    }
  }

  ${props =>
    props.selected
      ? css`
          color: ${({ theme }) => theme.text.primary};
          & ${SortAscIcon}, & ${SortDescIcon} {
            display: inline-flex;
          }
        `
      : null}

  ${props =>
    props.width
      ? css`
          width: ${props.width}px;
        `
      : null}
`;

export const ProductListingHeaderCellContent = styled.div<{ right?: boolean }>`
  display: flex;

  ${props =>
    props.right
      ? css`
          flex-direction: row-reverse;
          padding-right: ${layout.measurements.spacing050};
        `
      : null}
`;
